import {apiClient} from 'common/util/api-client';
import {apiHost} from 'common/util/shared-client';

import {Dashboard} from './dashboard-types';

export interface DashboardsSidenavResponse {
  favorites: Dashboard[];
  pinned: Dashboard[];
  created: Dashboard[];
}

export interface DashboardsSidenavOrdering {
  favorites_order: number[];
  pinned_order: number[];
  created_by_user_order: number[];
}

function getUrl(projectId) {
  return `${apiHost()}/api/app/projects/${projectId}/dashboard-sidenav`;
}

export async function getDashboardsSidenav(projectId) {
  return apiClient.get<DashboardsSidenavResponse>(getUrl(projectId));
}

export async function updateDashboardsSidenavOrdering(ordering: DashboardsSidenavOrdering, projectId) {
  return apiClient.put(getUrl(projectId), ordering);
}
